<div class="flex min-h-screen bg-amber-400" [@fadeIn]>
  <!-- Left side - Image/Banner -->
  <div
    class="hidden md:flex md:w-1/2 bg-cover bg-center relative"
    style="background-image: url('assets/repartidor.png')"
    >
    <div
      class="absolute inset-0 bg-black bg-gray-950/50 flex flex-col justify-end p-12 text-white"
      >
      <h2 class="text-4xl font-bold mb-2">Verificación de cuenta</h2>
      <p class="text-xl">Completa tu registro para disfrutar de todos los beneficios</p>
    </div>
  </div>

  <!-- Right side - Verification Form -->
  <div
    class="w-full md:w-1/2 flex items-center justify-center p-8 bg-amber-400 relative"
    style="
      background-image: url('assets/patrones/fondo_patron_subito.webp');
      background-size: 200px 200px;
      background-repeat: repeat;
      background-position: center;
    "
    >
    <!-- Home button positioned in the top-left corner -->
    <div class="absolute top-4 left-4">
      <shared-home-button></shared-home-button>
    </div>

    <div
      class="w-full max-w-2xl bg-white rounded-4xl shadow-lg p-8"
      [@formFields]
      >
      <div class="text-center mb-10">
        <div class="flex justify-center mb-4">
          <a href="/">
            <figure>
              <img
                src="assets/logo/logo_full.png"
                alt="Logo"
                class="h-20 w-auto"
                />
              </figure>
            </a>
          </div>
          <p class="text-gray-600 mt-2">Delivery instantáneo a tu puerta</p>
        </div>

        <h2 class="text-2xl font-bold text-gray-800 mb-6">Verificación de cuenta</h2>

        <div class="space-y-6">
          <div class="text-center">
            <p class="text-gray-600 mb-6">
              Estás a un paso de completar tu registro. Haz clic en el botón para verificar tu cuenta.
            </p>

            @if (!isVerified) {
              <div class="mb-6">
                <button
                  (click)="verifyAccount()"
                  [disabled]="isVerifying"
                  class="w-full bg-amber-500 hover:bg-amber-600 text-white font-bold py-3 px-4 rounded-md transition duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                  @if (!isVerifying) {
                    <span>Verificar mi cuenta</span>
                  }
                  @if (isVerifying) {
                    <span class="flex items-center justify-center">
                      <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Verificando...
                    </span>
                  }
                </button>
              </div>
            }

            @if (isVerified) {
              <div class="mb-6 p-4 bg-green-100 text-green-800 rounded-md">
                <div class="flex items-center justify-center mb-2">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <p class="font-medium">¡Tu cuenta ha sido verificada correctamente!</p>
                <p class="mt-2">Ahora puedes disfrutar de todos los beneficios de nuestra plataforma.</p>
              </div>
            }

            <div class="mt-8">
              <a
                routerLink="/login"
                class="text-amber-600 hover:text-amber-800 font-medium transition duration-300 ease-in-out"
                >
                Ir a iniciar sesión
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
